var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _c("div", { staticClass: "panel-heading pb-80" }, [
      _c("div", { staticClass: "row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.month,
                  expression: "month",
                },
              ],
              staticClass: "form-control",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.month = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.selectMonth,
                ],
              },
            },
            [
              _c("option", { attrs: { value: "0" } }, [_vm._v("Месяц (Все)")]),
              _vm._v(" "),
              _vm._l(12, function (n) {
                return _c(
                  "option",
                  {
                    domProps: { value: n },
                    model: {
                      value: _vm.month,
                      callback: function ($$v) {
                        _vm.month = $$v
                      },
                      expression: "month",
                    },
                  },
                  [_vm._v(_vm._s(_vm.monthByNum(n)))]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body" }, [
      _c(
        "div",
        { staticClass: "report-content" },
        [
          _vm.error
            ? _c("span", { staticClass: "error status_padding" }, [
                _c("h6", { staticClass: "text-center" }, [
                  _vm._v("По группам нет статистики"),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.error && _vm.loading
            ? _c("span", { staticClass: "loading status_padding" }, [
                _c("i", {
                  staticClass: "fa fa-spinner fa-pulse",
                  attrs: { "aria-hidden": "true" },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.active_tab == 2 && !_vm.error && !_vm.loading
            ? _c("GChart", {
                attrs: {
                  type: "PieChart",
                  data: _vm.chartData,
                  options: _vm.chartOptions,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h3", { staticClass: "panel-title text-center" }, [
        _vm._v("\n          Детализация причин\n          "),
        _c("i", {
          staticClass: "icon md-help-outline cursor-pointer",
          attrs: {
            "aria-hidden": "true",
            "data-toggle": "popover",
            "data-html": "true",
            "data-trigger": "click | hover",
            "data-content": "Рассчитывается на основании человек-группа",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }